"use strict";
/*
 * Created on 8.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ActionFeasibilityConverter_1 = require("./conversions/ActionFeasibilityConverter");

var LockActionResultConverter_1 = require("./conversions/LockActionResultConverter");

var LockActionResultConverterImpl_1 = require("./conversions/LockActionResultConverterImpl");
/**
 * @author MSu
 */


var WorkflowAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(WorkflowAppModule, _AppModule_1$AppModul);

  function WorkflowAppModule() {
    var _this;

    _classCallCheck(this, WorkflowAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'workflowAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WorkflowAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(LockActionResultConverter_1.LockActionResultConverter).to(LockActionResultConverterImpl_1.LockActionResultConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ActionFeasibilityConverter_1.ActionFeasibilityConverter).to(ActionFeasibilityConverter_1.ActionFeasibilityConverter).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return WorkflowAppModule;
}(AppModule_1.AppModule);

exports.WorkflowAppModule = WorkflowAppModule;